import hoistNonReactStatics from 'hoist-non-react-statics';
import { isFunction, pickBy } from 'lodash';
import React from 'react';
import { useQuery } from 'react-apollo';
import Error from '../components/utils/Error';
import LoadingMask from '../components/utils/LoadingMask/LoadingMask';
import Spinner from '../components/utils/Spinner';
const makeDataAccessHoc = (queryGql, gqlParams = {}) => ({ passLoader = false, enableLoaderMask = false, passError = false, inline = false, ...gqlRestParams } = {}) => Component => {
    const Hoc = props => {
        const { options = {}, ...queryRestParams } = {
            ...gqlParams,
            ...gqlRestParams,
        };
        const { loading, error, data } = useQuery(queryGql, {
            ...(isFunction(options) ? options(props) : options),
            ...queryRestParams,
        });
        let showSpinner = !passLoader && loading;
        let loaderMaskActive = false;
        if (showSpinner && enableLoaderMask) {
            showSpinner = false;
            loaderMaskActive = true;
        }
        if (showSpinner) {
            return <Spinner inline={inline}/>;
        }
        if (error && !passError) {
            return <Error error={error} inline={inline}/>;
        }
        const dataProps = pickBy(data, value => !isFunction(value));
        if (passLoader) {
            dataProps.loading = loading;
        }
        if (passError) {
            dataProps.error = error;
        }
        if (enableLoaderMask) {
            return (<LoadingMask active={loaderMaskActive}>
          <Component {...props} {...dataProps}/>
        </LoadingMask>);
        }
        return <Component {...props} {...dataProps}/>;
    };
    Hoc.displayName = `DataAccess(${Component.displayName || Component.name})`;
    return hoistNonReactStatics(Hoc, Component);
};
export default makeDataAccessHoc;
